var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-navigation-mobile-upper"},[_c('shared-stars',{attrs:{"quantity":_vm.responsiveStarsQty}}),_c('div',{staticClass:"c-navigation-mobile-upper__inner"},[_c('navigation-list',{attrs:{"is-mobile":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }